// Reject unknown envelopes and malformed rows instead of displaying an empty result.
export default function parseSiteDomains(data) {
  const rows = Array.isArray(data) ? data : data?.site_domains || data?.domains || data?.sites
  if (!Array.isArray(rows)) throw new Error('Invalid site domains response')
  const domains = rows.map(row => {
    const value = typeof row === 'string' ? row : row?.site_domain || row?.domain || row?.url
    if (typeof value !== 'string' || !value.trim()) throw new Error('Invalid site domain')
    return value.trim()
  })
  return [...new Set(domains)]
}
